<!--
  * name: ingredients
  * description: [Main] ingredients 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="ingredients"></bread-crumb>
    <page-title v-if="!isMo" class="mt-14"><strong>MAIN </strong> INGREDIENTS </page-title>
    <page-sub-title class="mb-180"></page-sub-title>
    <section>
       <img v-if="isMo" src="@/assets/images/ingredients/ingredients_mo.jpg" class="sect01_mo--img">
       <img v-else src="@/assets/images/ingredients/ingredients.jpg" class="sect01--img">
    </section>
  </div>
</template>

<script>
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import PageTitle from '@/components/page/PageTitle.vue';
import PageSubTitle from '@/components/page/PageSubTitle.vue';

export default {
  name: 'HowToUse',
  components: {
    BreadCrumb,
    PageTitle,
    PageSubTitle,
  },
  computed: {
    isMo(){
      const docWidth = window.clientWidth || document.documentElement.clientWidth;
      if(docWidth > 600){
        return false
      }else{
        return true
      }
    } 
  },
};
</script>

<style lang='scss' scoped>
.sect01 {
  &--maintit {
    margin-right: 4rem;
    @media (max-width: 1024px) {
      margin-right: 4rem;
    }
  } 
  &--img {
    background-size: 100%;
    width: 100%;
    @media (max-width: $mobile-size) {
      padding-bottom: 263%;
    }
  }
}

.sect01_mo {
  &--maintit {
    margin-right: 4rem;
    @media (max-width: 1024px) {
      margin-right: 4rem;
    }
  } 
  &--img {
    background-size: 100%;
    width: 100%;
  }
}
</style>
